module.exports = __webpack_public_path__ + "img/index-route-bg.0c6fbc6f.png";